var exports = {
  "Nr": "x234b8571--7816a1--card",
  "R_": "x234b8571--7816a1--heading",
  "QZ": "x234b8571--7816a1--heading__logo",
  "O0": "x234b8571--7816a1--rating",
  "F7": "x234b8571--7816a1--ratings__star",
  "h_": "x234b8571--7816a1--description",
};

module.exports = exports;
